import { ApiHelper, axiosInstance } from "../../utils/ApiHelper"
import moment from "moment"
import { change } from "redux-form"

import AnalyticsHelper from "../../utils/AnalyticsHelper"
import CloudEvent from "../../utils/CloudEvent"

export function togglePremium() {
  return (dispatch, getState) => {
    dispatch({ type: "TOGGLE_PREMIUM" })
  }
}

export function setAdvancedFilter(event, value, prev) {
  return (dispatch, getState) => {
    if (!getState().models.user.isPremium) {
      event.preventDefault() // prevent dispatch of rf field change
      dispatch(showPremiumModal())
      // TODO show spinner
      // on success, set values
      // on reject, reset values
    } else {
      dispatch({ type: "SET_ADVANCED_FILTER", filter: value })

      if (value == "pdf")
        dispatch(change("dataExportFormTeams", "purpose", "Work"))
    }
  }
}

// Fired onMount
export function getDataExports() {
  return (dispatch, getState) => {
    dispatch({ type: "GET_DATA_EXPORTS_TEAMS_REQUEST" })
    ApiHelper.getDataExports().then(response => {
      const dataExports = response.data
      dispatch({ type: "GET_DATA_EXPORTS_TEAMS_SUCCESS", dataExports })

      // check for pending data exports
      const hasGenerating = getState().models.dataExportsTeams.some(
        ({ isGenerating }) => isGenerating
      )
      if (hasGenerating) {
        getState().models.dataExportsTeams.forEach(dataExport => {
          let minutesOld = moment().diff(dataExport.last_modified, "minutes")
          if (minutesOld > 120 && dataExport.isGenerating) {
            dispatch({ type: "CANCEL_TEAMS_DATA_EXPORT", dataExport })
          }
        })

        setTimeout(() => {
          dispatch(getDataExports())
        }, 1000 * 10)
      }

      // NOTE alternative with setInterval https://pashacraydon.github.io/article/2016/10/15/polling-an-ajax-request-in-react-redux.html
    })
  }
}

export function generateReport(values) {
  return (dispatch, getState) => {
    const {
      range,
      file_type,
      purpose,
      income_source,
      entity,
      additional_recipients,
      email,
      type,
      context_user_email,
      send_to_integrations
    } = values

    const data = {
      data_export: {
        file_type,
        purpose,
        income_source,
        entity,
        additional_recipients,
        context_user_email,
        send_to_integrations,
        ...toRangeParams(range)
      }
    }
    const context_user_email_clean = context_user_email.replace(/@/i, "-")
    const payload =
      entity == "all" || entity == null || entity == ""
        ? [
            {
              file_name: `${context_user_email_clean}-trips-${moment(
                range[0]
              ).format("YYYY-MM-DD")}-${moment(range[1]).format(
                "YYYY-MM-DD"
              )}.${file_type}`,
              isGenerating: true,
              last_modified: new Date()
            },
            {
              file_name: `${context_user_email_clean}-transactions-${moment(
                range[0]
              ).format("YYYY-MM-DD")}-${moment(range[1]).format(
                "YYYY-MM-DD"
              )}.${file_type}`,
              isGenerating: true,
              last_modified: new Date()
            }
          ]
        : [
            {
              file_name: `${context_user_email_clean}-${entity}-${moment(
                range[0]
              ).format("YYYY-MM-DD")}-${moment(range[1]).format(
                "YYYY-MM-DD"
              )}.${file_type}`,
              isGenerating: true,
              last_modified: new Date()
            }
          ]

    // NOTE in theory, we shouldn't need to generate payload client side and should be getting it in response. However, we first need to ensure data is
    // 1) array format
    // 2) supports entity:"" ("All" option)

    dispatch({ type: "GENERATE_REPORT_TEAMS", payload })

    AnalyticsHelper.trackEvent(CloudEvent.DataExported)

    return ApiHelper.dataExport(data)
  }
}

function showPremiumModal() {
  return {
    type: "SHOW_MODAL",
    modalType: "UNLOCK_PREMIUM_MODAL",
    modalProps: {}
  }
}

// TODO same as in /work-hours
export const toRangeParams = range => {
  const start = range[0]
  const end = range[1]
  return {
    start_day: start.format("D"),
    start_month: start.format("M"),
    start_year: start.format("YYYY"),

    end_day: end.format("D"),
    end_month: end.format("M"),
    end_year: end.format("YYYY")
  }
}



// WEBPACK FOOTER //
// ./src/enterprise/data-export/actions.js